import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

// Radix Select does not accept an empty-string item value, so "all" is
// represented by a sentinel and translated back to '' for the caller.
const ALL = '__all__'

export interface FilterSelectOption {
    value: string
    label: string
}

interface FilterSelectProps {
    /** Accessible name of the trigger (e.g. "Filtrar estágio"). */
    label: string
    value: string
    onChange: (value: string) => void
    options: FilterSelectOption[]
    /** Text of the "no filter" option; omit it for a required choice. */
    allLabel?: string
    placeholder?: string
    disabled?: boolean
    className?: string
}

export const FilterSelect = ({
    label,
    value,
    onChange,
    options,
    allLabel,
    placeholder,
    disabled,
    className,
}: FilterSelectProps) => (
    <Select
        value={value === '' ? (allLabel ? ALL : undefined) : value}
        onValueChange={(next) => onChange(next === ALL ? '' : next)}
        disabled={disabled}
    >
        <SelectTrigger
            aria-label={label}
            className={cn(
                'h-9 w-auto min-w-[160px] gap-2 rounded-full border-border bg-secondary text-sm data-[placeholder]:text-muted-foreground',
                value !== '' && 'border-brand bg-accent text-accent-foreground',
                className
            )}
        >
            <SelectValue placeholder={placeholder ?? allLabel} />
        </SelectTrigger>
        <SelectContent>
            {allLabel && <SelectItem value={ALL}>{allLabel}</SelectItem>}
            {options.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                    {option.label}
                </SelectItem>
            ))}
        </SelectContent>
    </Select>
)
